/* anyaghasználat */
document.addEventListener('DOMContentLoaded', function () {
  

  const loadMoreBtn = document.querySelector('#load-more-materials');
  const showLessBtn = document.querySelector('#show-less-materials');

  const hiddenSections = [
    '#shopify-section-template--25598314905926__image_with_text_iYEmpL',
    '#shopify-section-template--25598314905926__image_with_text_XpbqQx',
    '#shopify-section-template--25598314905926__image_with_text_KtAkBz',
    '#shopify-section-template--25598314905926__image_with_text_pDBDTA',
    '#shopify-section-template--25598314905926__image_with_text_qB4qqQ',
    '#shopify-section-template--25598314905926__image_with_text_XxWfg6',
    '#shopify-section-template--25598314905926__image_with_text_MrpT3M',
    '#shopify-section-template--25598314905926__image_with_text_f9LE4G',
    '#shopify-section-template--25598314905926__image_with_text_QeEf8g'
  ];

  // Rejtsük el a szekciókat induláskor
  hiddenSections.forEach(selector => {
    const section = document.querySelector(selector);
    if (section) section.style.display = 'none';
  });

  // Mutass többet
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', e => {
      e.preventDefault();

      hiddenSections.forEach(sel => {
        const section = document.querySelector(sel);
        if (section) section.style.display = 'block';
      });

      loadMoreBtn.style.display = 'none';
      if (showLessBtn) showLessBtn.style.display = 'inline-flex';

      // Simán gördítsen az első új szekcióhoz
      setTimeout(() => {
        const firstSection = document.querySelector(hiddenSections[0]);
        if (firstSection) firstSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    });
  }

  // Mutass kevesebbet
  if (showLessBtn) {
    showLessBtn.addEventListener('click', e => {
      e.preventDefault();

      hiddenSections.forEach(sel => {
        const section = document.querySelector(sel);
        if (section) section.style.display = 'none';
      });

      showLessBtn.style.display = 'none';
      if (loadMoreBtn) loadMoreBtn.style.display = 'inline-flex';

      // Visszagörgetés a felső gombhoz
      if (loadMoreBtn) {
        loadMoreBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
});










/* anyaghasználat2 */
document.addEventListener('DOMContentLoaded', function () {
  // csak az #anyaghasznalat oldalon fusson
  if (!document.querySelector('#anyaghasznalat')) return;

  // minden image-with-text__text szekcióra
  document.querySelectorAll('#anyaghasznalat .image-with-text__text').forEach(section => {
    const paragraphs = section.querySelectorAll('p');
    if (paragraphs.length <= 1) return; // ha csak 1 bekezdés van, nincs mit törni

    // rejtett wrapper létrehozása
    const hiddenWrapper = document.createElement('div');
    hiddenWrapper.classList.add('hidden-text');
    hiddenWrapper.style.display = 'none';

    // az első bekezdésen túliakat áthelyezzük ide
    for (let i = 1; i < paragraphs.length; i++) {
      hiddenWrapper.appendChild(paragraphs[i]);
    }
    section.appendChild(hiddenWrapper);

    // gomb létrehozása
    const toggleBtn = document.createElement('button');
    toggleBtn.textContent = '+ Tudj meg többet';
    toggleBtn.classList.add('toggle-text-btn');
    toggleBtn.style.marginTop = '10px';
    toggleBtn.style.background = 'none';
    toggleBtn.style.border = 'none';
    toggleBtn.style.cursor = 'pointer';
    toggleBtn.style.fontWeight = 'bold';

    // eseménykezelő
    toggleBtn.addEventListener('click', () => {
      const isHidden = hiddenWrapper.style.display === 'none';
      hiddenWrapper.style.display = isHidden ? 'block' : 'none';
      toggleBtn.textContent = isHidden ? '- Mutass kevesebbet' : '+ Tudj meg többet';
    });

    section.appendChild(toggleBtn);
  });
});
  
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', () => {
    const productCount = document.querySelectorAll('#product-grid .grid__item').length;
    const countElem = document.getElementById('product-count-number');
    if(countElem) countElem.textContent = productCount;
  });



document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.indexOf("search") !== -1) {
    const breadcrumb = document.querySelector('nav.breadcrumb.text-center');
    if (breadcrumb) {
      breadcrumb.style.display = "none";
    }
  }
});



document.addEventListener("DOMContentLoaded", function () {
  // Mindkét email link szelektora
  const emailSelectors = [
    "#Banner-footer_style3 > div.footer__content-top.page-full-width.page-full-width_spacing > div > div > div.footer-block.grid__item.footer_address.left > div > div > div > ul > li.office-mail > a",
    "#shopify-section-template--25044293812550__b00cb236-0029-4168-99a5-576803e86dae > div > div > div > div > div > div.layout-contact-left > div > ul > li.office-mail > a"
  ];

  const emailLinks = emailSelectors
    .map(selector => document.querySelector(selector))
    .filter(link => link !== null);

  if (emailLinks.length === 0) return;

  // Nyelv meghatározása
  const locale = window.Shopify?.locale || 'hu'; // alapértelmezett magyar
  const texts = {
    hu: {
      copyBtn: "Másolás vágólapra →",
      copiedAlert: "Email cím másolva a vágólapra!",
      closeBtn: "X"
    },
    en: {
      copyBtn: "Copy to clipboard →",
      copiedAlert: "Email address copied to clipboard!",
      closeBtn: "X"
    }
  };
  const t = texts[locale] || texts.hu;

  // Overlay létrehozása
  const overlay = document.createElement("div");
  overlay.classList.add("overlay-popup");
  overlay.style.display = "none";
  document.body.appendChild(overlay);

  // Popup létrehozása
  const popup = document.createElement("div");
  popup.classList.add("popup");
  popup.style.display = "none";
  popup.innerHTML = `
    <button class="popup-close">${t.closeBtn}</button>
    <a href="mailto:daniel@splendorjewel.com">daniel@splendorjewel.com</a>
    <button id="copy-email" class="copy-btn">${t.copyBtn}</button>
  `;
  document.body.appendChild(popup);

  const closeButton = popup.querySelector(".popup-close");
  const copyButton = popup.querySelector("#copy-email");

  function openPopup(event) {
    event.preventDefault();
    overlay.style.display = "block";
    popup.style.display = "block";
  }

  function closePopup() {
    overlay.style.display = "none";
    popup.style.display = "none";
  }

  // Email linkekhez esemény
  emailLinks.forEach(link => {
    link.addEventListener("click", openPopup);
  });

  closeButton.addEventListener("click", closePopup);
  overlay.addEventListener("click", closePopup);

  copyButton.addEventListener("click", function () {
    const email = "daniel@splendorjewel.com";
    navigator.clipboard.writeText(email).then(() => {
      alert(t.copiedAlert);
    }).catch((err) => {
      
    });
  });
});







/* TOOLTIPES JS
function underlineWithTooltip(root = document.body) {
  const keyword = "Splendor";
  const tooltipText = "A Splendor ötvösműhelyében több mint 25 éve alkotunk személyes igényekre formatervezett, high-end ékszereket. Családi vállalkozásként hiszünk a kézműves minőség erejében, és abban, hogy minden ékszer személyes történetet mesél el.";

  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: node => {
        if (node.nodeValue.includes(keyword)) {
          console.log("Kulcsszót talált szövegben:", node.nodeValue);
          return NodeFilter.FILTER_ACCEPT;
        }
        return NodeFilter.FILTER_REJECT;
      }
    },
    false
  );

  const nodes = [];
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }

  console.log(`Összes talált szövegrészlet: ${nodes.length}`);

  for (const textNode of nodes) {
    const parent = textNode.parentNode;

    // Ne módosítsunk, ha már feldolgoztuk (pl. tooltip már rajta van)
    if (parent.closest('.splendor-tooltip')) {
      console.log("⚠ Már tooltipes, kihagyva:", textNode.nodeValue);
      continue;
    }

    const parts = textNode.nodeValue.split(keyword);
    const fragment = document.createDocumentFragment();

    parts.forEach((part, index) => {
      fragment.appendChild(document.createTextNode(part));
      if (index < parts.length - 1) {
        const span = document.createElement("span");
        span.textContent = keyword;
        span.className = "splendor-tooltip";
        span.style.textDecoration = "underline dotted";
        span.setAttribute("data-tooltip", tooltipText);
        fragment.appendChild(span);
      }
    });

    parent.replaceChild(fragment, textNode);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded - indul feldolgozás...");
  underlineWithTooltip();
});
 */


/* MUTASS TÖBBET */
document.addEventListener("DOMContentLoaded", function () {
 

  const $grid = $('.isotope-grid.template--25044293714246__home_isotope_gallery_XC4E3B');

  const allItems = $grid.find('.isotope-selector');
 

  // Adjunk ID-t az első 3 elemnek és a többi képnek
  allItems.each(function(index) {
    const id = "gallery-item-" + index;
    this.dataset.galleryId = id;
  });

  // első 3 ID
  const visibleIds = allItems.slice(0, 3).map(function () {
    return '[data-gallery-id="' + this.dataset.galleryId + '"]';
  }).get();

 
if ($grid.length > 0) {
  // Isotope inicializálás és filter csak az első 3 képre
  $grid.isotope({
    itemSelector: '.isotope-selector',
    filter: visibleIds.join(','),
    masonry: { gutter: 30 }
  });
}



 

  // Gomb létrehozása
  const $button = $('<button>Mutass többet</button>')
    .css({
      display: 'block',
      margin: '30px auto',
      padding: '10px 30px',
      fontSize: '16px',
      cursor: 'pointer',
          background: '#36496c',
    color: 'white',
    border: '0px',
    fontFamily: 'Palanquin',
    borderRadius: '20px 0'
    })
    .addClass('show-more-button');

  // Gomb esemény
  $button.on('click', function () {
    $grid.isotope({ filter: '*' }); // megjelenít minden képet
    $(this).remove();
  });

  // Gomb hozzáadása a galéria alá
  $grid.after($button);
});








/* MUTASS TÖBBET -MUTASS KEVESEBBET
document.addEventListener("DOMContentLoaded", function () {
  console.log("Dokumentum betöltve");

  const $grid = $('.isotope-grid.template--25044293714246__home_isotope_gallery_XC4E3B');
  const allItems = $grid.find('.isotope-selector');
  console.log('Összes kép:', allItems.length);

  // Adjunk egyedi ID-t az összes elemnek
  allItems.each(function(index) {
    const id = "gallery-item-" + index;
    this.dataset.galleryId = id;
  });

  // Első 3 kép szelektora
  const visibleIds = allItems.slice(0, 3).map(function () {
    return '[data-gallery-id="' + this.dataset.galleryId + '"]';
  }).get();

  const filter3 = visibleIds.join(',');

  // Isotope inicializálás első 3 képpel
  $grid.isotope({
    itemSelector: '.isotope-selector',
    filter: filter3,
    masonry: { gutter: 30 }
  });

  // Gombok létrehozása
  const $showMore = $('<button>Mutass többet</button>').css({
    display: 'block',
    margin: '30px auto',
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer'
  }).addClass('show-more-button');

  const $showLess = $('<button>Mutass kevesebbet</button>').css({
    display: 'block',
    margin: '30px auto',
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer'
  }).addClass('show-less-button').hide();

  // Gomb események
  $showMore.on('click', function () {
    console.log("Mutass többet gombra kattintva");
    $grid.isotope({ filter: '*' }); // összes kép
    $showMore.hide();
    $showLess.show();
  });

  $showLess.on('click', function () {
    console.log("Mutass kevesebbet gombra kattintva");
    $grid.isotope({ filter: filter3 }); // csak első 3 kép
    $showLess.hide();
    $showMore.show();
  });

  // Gombok hozzáadása
  $grid.after($showMore, $showLess);
  console.log("Gombok hozzáadva a DOM-hoz");
}); */







document.addEventListener("DOMContentLoaded", function () {
    if (window.location.href.includes("/products/")) {
      const breadcrumbs = document.querySelector(".breadcrumb");
      if (breadcrumbs) {
        breadcrumbs.style.display = "none";
      }
    }
  });

document.addEventListener("DOMContentLoaded", function () {
    if (window.location.href.includes("/collections/")) {
      const breadcrumbs = document.querySelector(".breadcrumb");
      if (breadcrumbs) {
        breadcrumbs.style.display = "none";
      }
    }
  });



/* BACKGROUND */
  document.addEventListener("DOMContentLoaded", function () {
    // Azonosítók vagy osztályok a négy szekcióhoz (példa: section--1, section--2, stb.)
    const section1 = document.querySelector('#shopify-section-template--25057487585606__166390473706e7065a');
    const section2 = document.querySelector('#shopify-section-template--25057487585606__image_with_text_KmNjdE');
    const section3 = document.querySelector('#shopify-section-template--25057487585606__image_with_text_CqDfBw');
    const section4 = document.querySelector('#shopify-section-template--25057487585606__image_with_text_JLD7DD');

    // Ellenőrzés, hogy mind megtalálható-e
    if (section1 && section2 && section3 && section4) {
      // Létrehozunk egy új wrapper divet
      const wrapper = document.createElement("div");
      wrapper.classList.add("background-wrapper");

      // Beszúrjuk a DOM-ba section1 elé
      section1.parentNode.insertBefore(wrapper, section1);

      // Áthelyezzük a szekciókat a wrapperbe
      wrapper.appendChild(section1);
      wrapper.appendChild(section2);
      wrapper.appendChild(section3);
      wrapper.appendChild(section4);
    }
  });




/* close button */
const insertCloseIcon = (btn) => {
  if (btn.innerHTML.trim() === '') {
    btn.innerHTML = '&times;';
    btn.style.fontSize = '24px';
    btn.style.lineHeight = '1';
    btn.style.fontWeight = 'bold';
    btn.style.cursor = 'pointer';
  }
};

// Már meglévő gombokra is fusson le egyszer
document.querySelectorAll('.mfp-close').forEach(insertCloseIcon);

// Figyeljük a DOM változásait
const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) { // csak elem node
        // Ha maga a gomb az új elem
        if (node.matches('.mfp-close')) {
          insertCloseIcon(node);
        }
        // Ha a gomb egy újabb elemben van
        node.querySelectorAll?.('.mfp-close').forEach(insertCloseIcon);
      }
    });
  }
});

// Indítjuk az observert
observer.observe(document.body, {
  childList: true,
  subtree: true
});




document.addEventListener('DOMContentLoaded', function () {
  var emailInput = document.getElementById('NewsletterForm--footer_style3');
  if (!emailInput) return;

  // Shopify nyelv lekérése
  var locale = window.Shopify?.locale || 'hu';

  // Placeholder szövegek nyelvenként
  var placeholders = {
    hu: 'E-mail címed',
    en: 'Your email address'
  };

  emailInput.placeholder = placeholders[locale] || placeholders.hu;
});



document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('Subscribe');

  if (button) {
    // Töröljük a meglévő SVG-t
    const oldSvg = button.querySelector('svg');
    if (oldSvg) oldSvg.remove();

    // Új SVG létrehozása HTML-ként
    const newSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
        <path d="M16.4404 0.298409C16.6369 0.441266 16.7172 0.631742 16.6815 0.869838L14.3958 14.5841C14.366 14.7567 14.2708 14.8907 14.1101 14.9859C14.0268 15.0335 13.9345 15.0573 13.8333 15.0573C13.7678 15.0573 13.6964 15.0425 13.619 15.0127L9.57437 13.3609L7.41366 15.9948C7.30652 16.1317 7.16068 16.2002 6.97616 16.2002C6.89878 16.2002 6.8333 16.1883 6.77973 16.1645C6.66664 16.1228 6.57586 16.0529 6.50741 15.9547C6.43896 15.8564 6.40473 15.7478 6.40473 15.6288V12.5127L14.119 3.05734L4.57437 11.3163L1.04759 9.86984C0.82735 9.7865 0.708302 9.62281 0.690445 9.37877C0.67854 9.14067 0.773779 8.96508 0.976159 8.85198L15.8333 0.280552C15.9226 0.22698 16.0178 0.200195 16.119 0.200195C16.2381 0.200195 16.3452 0.232933 16.4404 0.298409Z" fill="#1A1A1A"/>
      </svg>
    `;

    // Új SVG beszúrása a gombba
    button.insertAdjacentHTML('beforeend', newSvg);
  }
});





/* Address */
document.addEventListener('DOMContentLoaded', () => {
  // A cím ikon SVG-je
  const oldSvg = document.querySelector(
    '#Banner-footer_style3 li.address address svg'
  );

  if (oldSvg) {
    // Új SVG sablonja
    const newSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 11 19" fill="none">
        <path d="M6.96289 8.74623C6.96289 8.74623 7.08845 8.62068 7.33956 8.36956C7.59068 8.11844 7.71624 7.63797 7.71624 6.92815C7.71624 6.21833 7.46512 5.6123 6.96289 5.11007C6.46066 4.60784 5.85463 4.35672 5.14481 4.35672C4.43499 4.35672 3.82896 4.60784 3.32673 5.11007C2.8245 5.6123 2.57338 6.21833 2.57338 6.92815C2.57338 7.63797 2.8245 8.244 3.32673 8.74623C3.82896 9.24847 4.43499 9.49958 5.14481 9.49958C5.85463 9.49958 6.46066 9.24847 6.96289 8.74623ZM10.2877 6.92815C10.2877 7.65806 10.1772 8.25739 9.95619 8.72614L6.29994 16.5007C6.1928 16.7217 6.03376 16.8958 5.82282 17.023C5.61189 17.1503 5.38588 17.2139 5.14481 17.2139C4.90374 17.2139 4.67773 17.1503 4.4668 17.023C4.25586 16.8958 4.10017 16.7217 3.99972 16.5007L0.333426 8.72614C0.112444 8.25739 0.00195312 7.65806 0.00195312 6.92815C0.00195312 5.50851 0.504185 4.29646 1.50865 3.29199C2.51311 2.28753 3.72517 1.7853 5.14481 1.7853C6.56445 1.7853 7.77651 2.28753 8.78097 3.29199C9.78543 4.29646 10.2877 5.50851 10.2877 6.92815Z" fill="white"/>
      </svg>
    `;

    // Az eredeti SVG cseréje
    oldSvg.outerHTML = newSvg;
  }
});

/* email */
document.addEventListener('DOMContentLoaded', () => {
  // A cím ikon SVG-je
  const oldSvg = document.querySelector(
    '#Banner-footer_style3 .office-mail svg'
  );

  if (oldSvg) {
    // Új SVG sablonja
    const newSvg = `
     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
  <path d="M18 7.0692V16.8929C18 17.3348 17.8426 17.7132 17.5279 18.0279C17.2132 18.3426 16.8348 18.5 16.3929 18.5H1.60714C1.16518 18.5 0.78683 18.3426 0.472098 18.0279C0.157366 17.7132 0 17.3348 0 16.8929V7.0692C0 6.96875 0.0368304 6.88839 0.110491 6.82812C0.164062 6.78125 0.294643 6.66574 0.502232 6.48158C0.709821 6.29743 0.848772 6.1769 0.919085 6.11998C0.989397 6.06306 1.14174 5.9375 1.37612 5.7433C1.61049 5.54911 1.84487 5.36328 2.07924 5.18583C2.31362 5.00837 2.63504 4.76395 3.04353 4.45257C3.45201 4.14118 3.93248 3.78292 4.48493 3.37779C5.03739 2.97266 5.68192 2.50223 6.41853 1.96652C6.45201 1.93973 6.62779 1.8058 6.94587 1.56473C7.26395 1.32366 7.50335 1.14788 7.66406 1.03739C7.82478 0.926897 8.03906 0.80971 8.30692 0.685825C8.57478 0.561943 8.8058 0.5 9 0.5C9.1942 0.5 9.42522 0.561943 9.69308 0.685825C9.96094 0.80971 10.1786 0.928572 10.346 1.04241C10.5134 1.15625 10.7511 1.33036 11.0592 1.56473C11.3672 1.79911 11.5413 1.93304 11.5815 1.96652C12.3181 2.50223 12.9626 2.97266 13.5151 3.37779C14.0675 3.78292 14.548 4.14118 14.9565 4.45257C15.365 4.76395 15.6864 5.00837 15.9208 5.18583C16.1551 5.36328 16.3895 5.54911 16.6239 5.7433C16.8583 5.9375 17.0106 6.06306 17.0809 6.11998C17.1512 6.1769 17.2902 6.29743 17.4978 6.48158C17.7054 6.66574 17.8359 6.78125 17.8895 6.82812C17.9632 6.88839 18 6.96875 18 7.0692ZM12.3348 12.9453C14.096 11.6663 15.2511 10.8225 15.8002 10.4141C15.8739 10.3605 15.9157 10.2919 15.9258 10.2081C15.9358 10.1244 15.9141 10.0458 15.8605 9.9721L15.4788 9.44978C15.4252 9.37612 15.3549 9.33426 15.2679 9.32422C15.1808 9.31417 15.1004 9.33594 15.0268 9.38951C13.4799 10.5212 12.3315 11.3583 11.5815 11.9007C11.548 11.9208 11.3739 12.0513 11.0592 12.2924C10.7444 12.5335 10.505 12.7093 10.341 12.8198C10.1769 12.9302 9.96094 13.0474 9.69308 13.1713C9.42522 13.2952 9.1942 13.3571 9 13.3571C8.8058 13.3571 8.57478 13.2952 8.30692 13.1713C8.03906 13.0474 7.8231 12.9302 7.65904 12.8198C7.49498 12.7093 7.25558 12.5335 6.94085 12.2924C6.62612 12.0513 6.45201 11.9208 6.41853 11.9007C5.17299 11.0033 4.02455 10.1663 2.97321 9.38951C2.89955 9.33594 2.8192 9.31417 2.73214 9.32422C2.64509 9.33426 2.57478 9.37612 2.52121 9.44978L2.13951 9.9721C2.08594 10.0458 2.06417 10.1244 2.07422 10.2081C2.08426 10.2919 2.12612 10.3605 2.19978 10.4141C2.74888 10.8225 3.90402 11.6663 5.66518 12.9453C5.73214 12.9989 5.89955 13.1261 6.16741 13.327C6.43527 13.5279 6.6529 13.6853 6.82031 13.7991C6.98772 13.9129 7.20201 14.0452 7.46317 14.1959C7.72433 14.3465 7.98382 14.4587 8.24163 14.5324C8.49944 14.606 8.75223 14.6429 9 14.6429C9.24777 14.6429 9.50056 14.606 9.75837 14.5324C10.0162 14.4587 10.2807 14.3432 10.5519 14.1858C10.8231 14.0285 11.0391 13.8962 11.1998 13.7891C11.3605 13.6819 11.5781 13.5229 11.8527 13.3119C12.1272 13.101 12.2879 12.9788 12.3348 12.9453Z" fill="white"/>
</svg>
    `;

    // Az eredeti SVG cseréje
    oldSvg.outerHTML = newSvg;
  }
});




/* header */
document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById("header");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 10) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  let lastScroll = window.pageYOffset;
  const loc = document.querySelector('.localization_mobile');

  if (!loc) return;

  window.addEventListener("scroll", function () {
    let currentScroll = window.pageYOffset;

    // lefelé görgetés → eltűnik
    if (currentScroll > lastScroll && currentScroll > 20) {
      loc.style.display = "none";
    }
    // felfelé görgetés → megjelenik
    else {
      loc.style.display = "flex";
    }

    lastScroll = currentScroll;
  });
});












document.addEventListener("DOMContentLoaded", function () {
  console.log("[locale-switch] DOMContentLoaded");

  // A lenyíló ország listában lévő elemek (ezekre kattint a user)
  const countryLinks = document.querySelectorAll('#FooterCountryList a[data-value]');
  console.log('[locale-switch] Talált ország linkek:', countryLinks.length);

  countryLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const selectedCountry = e.currentTarget.getAttribute("data-value");
      console.log("[locale-switch] Ország választva:", selectedCountry);

      let localeCode = null;

      // Ország → nyelv logika
      if (["DE", "AT", "ES", "FR"].includes(selectedCountry)) {
        localeCode = "en";
      } else if (selectedCountry === "HU") {
        localeCode = "hu";
      }

      // Új form összeállítása
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "/localization";

      form.innerHTML = `
        <input type="hidden" name="form_type" value="localization">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="_method" value="put">
        <input type="hidden" name="country_code" value="${selectedCountry}">
        ${localeCode ? `<input type="hidden" name="locale_code" value="${localeCode}">` : ""}
      `;

      document.body.appendChild(form);

      console.log("[locale-switch] Form submit:", {
        country: selectedCountry,
        locale: localeCode,
      });

      form.submit();
    });
  });
});




/*document.addEventListener("DOMContentLoaded", function() {
  // Ellenőrizzük, hogy a popup már megjelent-e
  if (localStorage.getItem("popupShown")) {
    return; // Ha már látta, nem csinálunk semmit
  }

  const overlay = document.createElement("div");
  overlay.style.position = "fixed";
  overlay.style.top = "0";
  overlay.style.left = "0";
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  overlay.style.backgroundColor = "rgba(0,0,0,0.5)";
  overlay.style.display = "flex";
  overlay.style.alignItems = "center";
  overlay.style.justifyContent = "center";
  overlay.style.zIndex = "9999";

  const popup = document.createElement("div");
  popup.style.backgroundColor = "#fff";
  popup.style.padding = "30px";
  popup.style.borderRadius = "10px";
  popup.style.maxWidth = "1200px";
  popup.style.width = "80%";
  popup.style.textAlign = "center";
  popup.style.position = "relative";
  popup.style.boxShadow = "0 4px 15px rgba(0,0,0,0.3)";

  const closeBtn = document.createElement("span");
  closeBtn.textContent = "×";
  closeBtn.style.position = "absolute";
  closeBtn.style.top = "10px";
  closeBtn.style.right = "15px";
  closeBtn.style.fontSize = "24px";
  closeBtn.style.cursor = "pointer";
  closeBtn.style.fontWeight = "bold";
  closeBtn.addEventListener("click", function() {
    document.body.removeChild(overlay);
    localStorage.setItem("popupShown", "true"); // elmentjük, hogy már látta
  });

  const message = document.createElement("p");
  message.style.marginBottom = "20px";

  const button = document.createElement("a");
  button.style.display = "inline-block";
  button.style.padding = "20px 30px";
  button.style.border = "none";
  button.style.borderRadius = "20px 0 20px 0";
  button.style.backgroundColor = "#36496C";
  button.style.color = "#fff";
  button.style.fontSize = "16px";
  button.style.cursor = "pointer";
  button.style.textDecoration = "none";

  // Angol vagy magyar verzió URL alapján
  if (window.location.pathname.startsWith("/en/")) {
    message.innerHTML = `
      Dear Customers!<br><br>
      Orders for home delivery can be placed until December 19 in our webshop.<br>
      We welcome customers in person at the following times: December 21, 10 AM - 2 PM, December 22, 10 AM - 2 PM, December 23, 9 AM - 6 PM.<br><br>
      Our jewelry salon will be closed from December 24 until January 12, 2026. First working day: January 13.
    `;
    button.textContent = "Go to webshop";
    button.href = "/en/pages/brilldor-by-splendor";
  } else {
    message.innerHTML = `
      Kedves Vásárlóink!<br><br>
      A megrendeléseket házhoz szállítás esetén december 19-éig tudják leadni a webshopunkban.<br>
      Személyesen a következő időpontokban várjuk szeretettel ügyfeleinket: december 21.-e 10-14h, december 22.-e 10-14h, 23.-a 9-18h.<br><br>
      Ékszer szalonunk december 24.-től 2026 január 12.-ig zárva tart. Első munkanapunk január 13.-a
    `;
    button.textContent = "Irány a webshop";
    button.href = "/pages/brilldor-by-splendor";
  }

  // Gomb esemény: bezárja a popupot és elmenti, hogy már látta
  button.addEventListener("click", function() {
    document.body.removeChild(overlay);
    localStorage.setItem("popupShown", "true");
  });

  popup.appendChild(closeBtn);
  popup.appendChild(message);
  popup.appendChild(button);
  overlay.appendChild(popup);

  document.body.appendChild(overlay);
});*/





// mérettáblázat
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('#MainProduct-template--25044294271302__main > div > div > div > div > div.product__info-wrapper.grid__item > div:nth-child(3)').forEach(function (accordion) {
    const content = accordion.querySelector('.accordion__content');

    if (!content) return;

    // szöveg + képek ellenőrzése
    const hasText = content.textContent.trim().length > 0;
    const hasImages = content.querySelectorAll('img').length > 0;

    if (!hasText && !hasImages) {
      accordion.style.display = 'none';
    }
  });
});